import { UIStyleConstants } from "../constants/ApplicationConstants/UIStyleConstants";
import { UserInterface } from "../shared/interface/auth/User.interface";

class UIConfiguration {
  public static updateUIConfig(userData: UserInterface) {
    /* set primary, secondary colors and logo */
    const appPrimaryColor = userData?.config?.theme?.PRIMARY_COLOR ?? UIStyleConstants.PRIMARY_COLOR;
    const appSecondaryColor = userData?.config?.theme?.SECONDARY_COLOR ?? UIStyleConstants.SECONDARY_COLOR;

    /* this update will directly update the CSSDOm which will be applied to all the components. */
    document.documentElement.style.setProperty("--app-primary-color", appPrimaryColor);
    document.documentElement.style.setProperty("--app-secondary-color", appSecondaryColor);
  }
}

export default UIConfiguration;
